module.exports = __webpack_public_path__ + "img/hero.ea0a00f4.jpg";